import { lazy } from 'react';

const Divider = lazy(() => import('./Divider'));

export { Divider };
